import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CredentialsService } from '@app/core';
import { QuesitonWeightIcon } from '@app/shared/common/constants';
import { AnswerType, GPTEvalStatus } from '@app/shared/common/enums';
import { EDecisionType, EDetectionType, QuestionCollectionCategoryEnum, QuestionExpectedAnswerType } from '@app/shared/common/enums';
import { ApplicantDetailStepScoreCommunicationService } from '@app/vinter/services/applicant-detail-stepscore-communation.service';

@Component({
  selector: 'app-step-question-result-list',
  templateUrl: './step-question-result-list.component.html',
  styleUrls: ['./step-question-result-list.component.scss']
})
export class StepQuestionResultListComponent implements OnInit{


  @Input() questionList: any;
  @Input() applicationStepId: string; 
  @Output() onHideAnswerSidebarForScoreChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() stepVinterScore = new EventEmitter<number>();
  QuestionExpectedAnswerType = QuestionExpectedAnswerType;
  questionCollectionCategories = QuestionCollectionCategoryEnum;
  questionWeightIconPath = QuesitonWeightIcon;
  answerSidebarVisible : boolean = false;
  selectedQuestion: any;
  isNextQuestionMultipleChoice: boolean;
  isScoreChanged: boolean = false;
  questionScoreDecPart: number;
  questionScoreIntPart: number;
  isCurrentQuestionMultipleChoice: boolean;
  isVinterSimpleLicenseValid: boolean = true;
  showSimpleVinterScoreChangeSidebar: boolean = false;
  GPTEvalStatus = GPTEvalStatus;

  constructor(
    private communicationService: ApplicantDetailStepScoreCommunicationService,
    private credentialsService: CredentialsService,
  ) { }
  decisionTypeEnum = EDecisionType;
  detectionTypeEnum = EDetectionType;

  colorRanges = [
    { min: 90, max: 100, color: '#16ba13' },
    { min: 80, max: 90, color: '#01ce2d' },
    { min: 70, max: 80, color: '#6fe819' },
    { min: 60, max: 70, color: '#afe705' },
    { min: 50, max: 60, color: '#d7ee06' },
    { min: 40, max: 50, color: '#fbdf0b' },
    { min: 30, max: 40, color: '#fdba04' },
    { min: 10, max: 30, color: '#ff8307' },
    { min: 0, max: 10, color: '#F91E00' }
  ];

  ngOnInit(): void {
    this.isVinterSimpleLicenseValid = this.credentialsService.getIsVinterSimpleLicenseValid();;
  }

  onHideAnswerSidebar(isScoreChanged){
    this.answerSidebarVisible = false;
    this.selectedQuestion = null;
    if(isScoreChanged){
      this.communicationService.requestProfileUpdate();
      this.onHideAnswerSidebarForScoreChange.emit(isScoreChanged)
    }
  }

  handleClick(relation: any): void {
    if (this.isVinterSimpleLicenseValid) {
      this.giveScore(relation);
    } else {
      this.openAnswerSidebar(relation);
    }
  }
  getProgressBarWidth(relation: any): number {
    const score = relation?.question?.gptScore;
    if (score !== 0) return score;
    // Cevaplanmış ama yanlış çoktan seçmeli soruda bar tamamen kırmızı dolsun
    if (relation?.question?.expectedAnswerType === AnswerType.MultipleChoice && relation?.question?.isAnswered) {
      return 100;
    }
    return 2;
  }

  getSliderColor(value: number): string {
    const range = this.colorRanges.find(r => value >= r.min && value <= r.max);
    return range ? range.color : '#ECECEC';
  }

  onAverageStepVinterScore(score: number) {
    this.stepVinterScore.emit(score); 
  }
  handleScoreFromSidebar(data: { questionId: number; score: number }): void {
    const relation = this.questionList.questionCollectionQuestionRelations.find(
      (r) => r.question.id === data.questionId
    );
  
    if (relation) {
      const intPart = Math.floor(data.score);
      const decPart = Math.round((data.score - intPart) * 100);
  
      relation.question.scoreIntPart = intPart;
      relation.question.scoreDecPart = decPart;
      relation.question.isHRScoreChanged = true;
      relation.question.gptScore = data.score;
      relation.question.progressBarColor = this.getSliderColor(data.score);
    }
  }
  
  
  onHideSimpleVinterAnswerSidebar(isScoreChanged){
    this.showSimpleVinterScoreChangeSidebar = false;
    this.selectedQuestion = null;
    if(isScoreChanged){
      this.communicationService.requestProfileUpdate();
      this.onHideAnswerSidebarForScoreChange.emit(isScoreChanged)
    }
  }

  giveScore(relation: any) {
    this.selectedQuestion = {
      ...relation.question,
      order: relation.order,
      weight: relation.weight,
      questionCollectionCategory: this.questionList.questionCollectionCategory
    };

    this.questionScoreDecPart = relation.question.scoreDecPart;
    this.questionScoreIntPart = relation.question.scoreIntPart;
    this.isCurrentQuestionMultipleChoice = relation.question.expectedAnswerType == AnswerType.MultipleChoice;
    this.showSimpleVinterScoreChangeSidebar = true;
}

  openAnswerSidebar(relation:any){
    this.selectedQuestion = relation.question;
    this.selectedQuestion.order = relation.order;
    this.selectedQuestion.weight = relation.weight;
    this.selectedQuestion.questionCollectionCategory = this.questionList.questionCollectionCategory;
    this.answerSidebarVisible = true;
  }

  getPreviousOrNextQuestion(event){
  var questionRelationsCopy = JSON.parse(JSON.stringify(this.questionList.questionCollectionQuestionRelations));
  const sortedRelations = questionRelationsCopy.sort(
      (a, b) => b.order - a.order
    );
  const lastQuestion = sortedRelations[0];
  if(event != 0 && event >! lastQuestion.order){
    const previousQuestionRelation = this.questionList.questionCollectionQuestionRelations.filter(x => x.order == event)[0]
    this.selectedQuestion = previousQuestionRelation.question;
    this.selectedQuestion.order = previousQuestionRelation.order;
    this.selectedQuestion.weight = previousQuestionRelation.weight;
    this.selectedQuestion.questionCollectionCategory = this.questionList.questionCollectionCategory;
    }
  }

  getPreviousOrNextQuestionForSimpleVinter(order) {
    const questionRelationsCopy = JSON.parse(JSON.stringify(this.questionList.questionCollectionQuestionRelations));
    const sortedRelations = questionRelationsCopy.sort((a, b) => b.order - a.order);
    const lastQuestion = sortedRelations[0];
  
    if (order != 0 && order <= lastQuestion.order) {
      const previousQuestionRelation = this.questionList.questionCollectionQuestionRelations.find(x => x.order === order);
  
      this.selectedQuestion = {
        ...previousQuestionRelation.question,
        order: previousQuestionRelation.order,
        weight: previousQuestionRelation.weight,
        questionCollectionCategory: this.questionList.questionCollectionCategory
      };
      this.questionScoreDecPart = previousQuestionRelation.question.scoreDecPart;
      this.questionScoreIntPart = previousQuestionRelation.question.scoreIntPart;
      this.isNextQuestionMultipleChoice = previousQuestionRelation.question.expectedAnswerType == AnswerType.MultipleChoice;
    }
  }
  updateSuspicionOfCheating(event:any)
  {
   const relations = this.questionList.questionCollectionQuestionRelations;
   const relationItem = relations.find(r => r.questionID === event.questionId);
   if (event.detectionType == EDetectionType.FaceDetected)
    {
      relationItem.isFaceDetected = event.decisionType == EDecisionType.HRRejected ? false : true;
    }
    if (event.detectionType == EDetectionType.MultiFaceDetected)
    {
      relationItem.isMultipleFaceDetected = event.decisionType == EDecisionType.HRRejected ? false : true;

    }
    if (event.detectionType == EDetectionType.UnverifiedNonFace || event.detectionType == EDetectionType.VerifiedNonFace)
    {
      relationItem.faceDetectionStatus = event.decisionType == EDecisionType.HRRejected ? true : false;
    }
    this.updateAnyLogExist(relationItem);

  }
  private updateAnyLogExist(relationItem: any): void {
    const {
      isFaceDetected,
      isImproprietySpeech,
      isMultipleFaceDetected,
      faceDetectionStatus,
      isSwitchedTab
    } = relationItem;
  
    relationItem.isAnyCheatLogExist = (
      isFaceDetected ||
      isImproprietySpeech ||
      isMultipleFaceDetected ||
      !faceDetectionStatus ||
      isSwitchedTab
    );
  }
}
